<template>
  <div class="reservation-experiences-container mx-auto position-relative" v-if="upcomingReservation && upcomingReservation.lodging && upcomingReservation.lodging.experiences">
    <div class="experiences-section">
      <!-- Title and Subtitle -->
      <div class="experiences-header">
        <h2 class="merriweather-reg-24">Préparez votre escapade au {{ upcomingReservation.lodging.name }}</h2>
        <h3 class="raleway-reg-p15">À l’approche de votre escapade au {{ upcomingReservation.lodging.name }}, Hortense vous propose un carnet d’adresses sélectionné pour découvrir des expériences authentiques.</h3>
      </div>

      <!-- Experience Category Filters -->
      <div class="exp-filter" v-if="categories.length > 0">
        <ul class="filter-exp">
          <li v-for="category in categories" :key="category">
            <a class="exp-category" href="#" :class="{ active: selectedCategory === category }" @click.prevent="selectedCategory = category">
              <p class="raleway-reg-p15" :data-value="category">{{ formatCategoryName(category) }}</p>
            </a>
          </li>
        </ul>
      </div>

      <!-- Experiences Slider -->
      <slither-slider 
        v-if="experiencesFiltered && experiencesFiltered.length > 0" 
        ref="slither" 
        class="px-5"
        :options="{ numberOfSlides: 2, dots: false, controls: true }"
      >
        <div v-for="experience in experiencesFiltered" :key="experience.id">
          <Cardexplodging 
            :experience="experience" 
            :user="user"
            @connection="$emit('connection')" 
            @showOnMap="showExperienceOnMap"
          />
        </div>
        <template slot="previous">
          <div class="circle-icon previous-slide-button">
            <img src="../../images/arrow-left.svg" alt="Previous" />
          </div>
        </template>
        <template slot="next">
          <div class="circle-icon next-slide-button">
            <img src="../../images/arrow-right.svg" alt="Next" />
          </div>
        </template>
      </slither-slider>

      <!-- Empty State -->
      <div class="col-lg-12 no-experience" v-if="experiencesFiltered && experiencesFiltered.length === 0">
        <p class="raleway-reg-p15 text-center">
          Hortense est à la recherche d'expériences à vous proposer près de cet hébergement
        </p>
      </div>

      <!-- Address Book Button -->
      <div class="dicsover-lodging-state mt-4" v-if="upcomingReservation.lodging.address_book">
        <a :href="'/' + upcomingReservation.lodging.address_book.slug" class="hortense-btn-primary" target="_blank">
          DÉCOUVREZ NOTRE CARNET D'ADRESSES
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Cardexplodging from '../cards/Cardexplodging.vue';

export default {
  name: 'ReservationExperiences',
  components: {
    Cardexplodging,
  },
  props: {
    upcomingReservation: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      selectedCategory: 'culturelles',
      categories: [
        'culturelles',
        'au naturel',
        'au bord de l\'eau',
        'sportives',
        'immersives',
        'culinaires',
        'diy',
        'oenologiques',
      ],
    };
  },
  computed: {
    experiencesFiltered() {
      if (!this.upcomingReservation || !this.upcomingReservation.lodging || !this.upcomingReservation.lodging.experiences) {
        return [];
      }
      return this.upcomingReservation.lodging.experiences.filter(
        (exp) => exp.category_name === this.selectedCategory && exp.photo_key
      );
    },
  },
  methods: {
    formatCategoryName(category) {
      return category.charAt(0).toUpperCase() + category.slice(1);
    },
    showExperienceOnMap(experience) {
      this.$emit('showExperienceOnMap', experience);
    },
  },
};
</script>

<style scoped lang="scss">
.reservation-experiences-container {
  width: 90%;
  margin: 40px 0;
}

.experiences-section {
  padding: 0 20px;
}

.experiences-header {
  margin-bottom: 30px;

  h2 {
    margin-bottom: 10px;
    color: #000;
  }

  h3 {
    color: #000;
    margin: 0;
  }
}

.exp-filter {
  margin-bottom: 30px;
  overflow-x: auto;

  .filter-exp {
    list-style: none;
    padding-left: 0;
    text-transform: uppercase;
    padding-bottom: 1rem;
    display: flex;
    gap: 40px;
    flex-wrap: wrap;

    li {
      display: inline-block;
      padding-bottom: 0.5rem;

      .exp-category {
        text-decoration: none;
        color: black;
        transition: all 0.2s ease;

        p {
          opacity: 0.4;
          margin: 0;
          text-transform: uppercase;
          font-size: 15px;
          font-weight: 400;
        }

        &:hover {
          p {
            opacity: 1;
          }
        }

        &.active {
          border-bottom: 2px solid #2C5E4B;
          font-family: 'Raleway', sans-serif;
          font-weight: 600 !important;
          font-size: 15px;
          display: flex;
          align-items: baseline;
          justify-content: space-between;

          p {
            opacity: 1;
            margin-bottom: 0;
          }
        }
      }
    }
  }
}

.no-experience {
  text-align: center;
  padding: 40px 20px;
  background: #f9f9f9;
  border-radius: 8px;
  margin: 20px 0;
}

.dicsover-lodging-state {
  text-align: center;
  padding: 20px 0;
}

.circle-icon {
  width: 43px;
  height: 43px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: #00000053 0% 0% no-repeat padding-box;
}
.previous-slide-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0%;
  color: #F7F7F7;
  background: #00000053 0% 0% no-repeat padding-box;

  img {
    width: 26px;
    height: 15px;
  }
}

.next-slide-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0%;
  color: #F7F7F7;
  background: #00000053 0% 0% no-repeat padding-box;

  img {
    width: 26px;
    height: 15px;
  }
}

@media (max-width: 768px) {
  .experiences-section {
    padding: 0 16px;
  }

  .experiences-header {
    h2 {
      font-size: 20px;
    }

    h3 {
      font-size: 15px;
    }
  }

  .exp-filter .filter-exp {
    gap: 12px;
  }
}
</style>
<style lang="scss">
.experiences-section {
  .slither-slider-slide {
    grid-template-columns: repeat(2, minmax(0px, 1fr)) !important;
  }
}
</style>
